<template>
  <el-container class="layout-container">
    <el-header class="header" height="190px">
      <el-container class="header-content">
        <img
          src="../assets/images/header_logo.png"
          alt=""
          class="logo"
          @click="goHome"
        />
        <div class="user-bar">
          <el-popover placement="top" width="54" trigger="hover" ref="popover">
            <div class="help">帮助文档</div>
          </el-popover>
          <svg
            class="svg-icon file"
            aria-hidden="true"
            v-popover:popover
            @click="goHelp"
          >
            <use :xlink:href="'#icon-file'"></use>
          </svg>
          <svg class="svg-icon avatar" aria-hidden="true">
            <use :xlink:href="'#icon-avatar'"></use>
          </svg>
          <span>{{ userName }}</span>
          <svg class="svg-icon quit" aria-hidden="true" @click="logout">
            <use :xlink:href="'#icon-quit'"></use>
          </svg>
        </div>
      </el-container>
    </el-header>
    <el-container class="main-bg">
      <el-container :class="fixedNav ? 'main fixed' : 'main'">
        <el-menu
          :class="fixedNav ? 'menu fixed' : 'menu'"
          router
          :default-active="$route.path"
          mode="horizontal"
          text-color="#595959"
          active-text-color="#3fb7ff"
        >
          <el-submenu index="0" style="padding-left: 37px">
            <template slot="title">
              <span>模板中心</span>
            </template>
            <el-menu-item index="/template/list">
              <span slot="title">— 图片</span>
            </el-menu-item>
            <el-menu-item index="/video/template">
              <span slot="title">— 视频</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="1"  v-if="hasAuth('141')">
            <template slot="title">
              <span>数据报表</span>
            </template>
            <el-menu-item index="/template/analysis">
              <span slot="title">— 模板点击率排行</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/material/list"  v-if="hasAuth('151')">
            <span slot="title">素材优选</span>
          </el-menu-item>
          <el-submenu index="2" v-if="hasAuth('121')">
            <template slot="title">
              <span>我的设计</span>
            </template>
            <el-menu-item index="/design/private/image">
              <span slot="title">— 我的创意库</span>
            </el-menu-item>
            <el-menu-item index="/design/template/image">
              <span slot="title">— 我的模板库</span>
            </el-menu-item>
            <!--<el-menu-item index="/roles/list">-->
            <!--<span slot="title">角色管理</span>-->
            <!--</el-menu-item>-->
          </el-submenu>
          <el-submenu index="3" v-if="hasAuth('131')||hasAuth('133')||hasAuth('134')||hasAuth('135')">
            <template slot="title">
              <span>后台设置</span>
            </template>
            <el-menu-item :index="hasAuth('131') ? '/users/list' : '/customers/list'"  v-if="hasAuth('131')||hasAuth('133')||hasAuth('134')">
              <span slot="title">— 权限管理</span>
            </el-menu-item>
            <el-menu-item index="/element/list"  v-if="hasAuth('135')">
              <span slot="title">— 元素管理</span>
            </el-menu-item>
            <!--<el-menu-item index="/roles/list">-->
            <!--<span slot="title">角色管理</span>-->
            <!--</el-menu-item>-->
          </el-submenu>
        </el-menu>
        <el-main class="main-content">
          <div v-show="showAside === 'template'" class="aside">
            <el-menu
              router
              :default-active="$route.path"
              active-text-color="#3fb7ff"
            >
              <div class="type-name">图片</div>
              <el-menu-item index="/template/list">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-list"></use>
                  </svg>
                  <span>图片模板</span>
                </span>
              </el-menu-item>
              <div class="type-name">视频</div>
              <el-menu-item index="/video/template">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-list"></use>
                  </svg>
                  <span>视频模板</span>
                </span>
              </el-menu-item>
            </el-menu>
          </div>
          <div v-show="showAside === 'settings'" class="aside">
            <el-menu
              router
              :default-active="$route.path"
              active-text-color="#3fb7ff"
            >
              <div class="type-name" v-if="hasAuth('131')||hasAuth('133')||hasAuth('134')||hasAuth('135')">权限管理</div>
              <el-menu-item index="/users/list" v-if="hasAuth('131')">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-account"></use>
                  </svg>
                  <span>员工账号</span>
                </span>
              </el-menu-item>
              <el-menu-item index="/customers/list" v-if="hasAuth('133')">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-customer"></use>
                  </svg>
                  <span>客户账号</span>
                </span>
              </el-menu-item>
              <el-menu-item index="/companies/list"  v-if="hasAuth('134')">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-company"></use>
                  </svg>
                  <span>客户管理</span>
                </span>
              </el-menu-item>
              <div class="type-name" v-if="hasAuth('135')">元素管理</div>
              <el-menu-item index="/element/list"  v-if="hasAuth('135')">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-puzzle"></use>
                  </svg>
                  <span>元素管理</span>
                </span>
              </el-menu-item>
            </el-menu>
          </div>
          <div v-show="showAside === 'design'" class="aside">
            <el-menu
              router
              :default-active="$route.path"
              active-text-color="#3fb7ff"
            >
              <div class="type-name">我的创意库</div>
              <el-menu-item index="/design/private/image">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-img"></use>
                  </svg>
                  <span>图片</span>
                </span>
              </el-menu-item>
              <el-menu-item index="/design/private/video">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-video"></use>
                  </svg>
                  <span>视频</span>
                </span>
              </el-menu-item>
              <div class="type-name">我的模板库</div>
              <el-menu-item index="/design/template/image">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-img"></use>
                  </svg>
                  <span>图片</span>
                </span>
              </el-menu-item>
              <el-menu-item index="/design/template/video">
                <span slot="title">
                  <svg class="svg-icon list" aria-hidden="true">
                    <use xlink:href="#icon-video"></use>
                  </svg>
                  <span>视频</span>
                </span>
              </el-menu-item>
            </el-menu>
          </div>
          <router-view style="flex: 1;padding: 0px 24px 24px 24px;" />
        </el-main>
      </el-container>
    </el-container>
    <el-container class="footer">
      <p>Copyright©FancyDigital.All Rights reserved.</p>
      <p>京ICP备15031715号-2</p>
    </el-container>
    <el-backtop
      style="width:32px;height:32px;border-radius:4px;background:transparent;"
    >
      <div class="backtop">
        <svg class="svg-icon" aria-hidden="true">
          <use xlink:href="#icon-top"></use>
        </svg>
      </div>
    </el-backtop>
  </el-container>
</template>

<script>
import config from 'utils/config';
import { hasAuth } from 'utils/auth';
import _ from 'lodash';

export default {
  data() {
    return {
      userName: '',
      fixedNav: false
    };
  },
  mounted() {
    let _this = this;
    this.userName = config.USER_NAME;
    this.$nextTick(() => {
      window.addEventListener(
        'scroll',
        function() {
          _this.onScroll();
        },
        true
      );
    });
  },
  methods: {
    onScroll() {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      this.fixedNav = scrollTop >= 125;
    },
    logout() {
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
    },
    hasAuth(val){
      return hasAuth(val)
    },
    goHelp() {
      this.$router.push('/help/templateList');
    },
    goHome() {
      this.$router.push('/template/list');
    }
  },
  computed: {
    showAside() {
      return this.$route.meta.showAside;
    }
  },
  components: {}
};
</script>
<style lang="scss">
.layout-main {
  background: white;
  padding: 20px 24px;
  border-radius: 4px;
}
</style>
<style scoped lang="scss">
.help {
  width: 100%;
  text-align: center;
  font-size: 10px;
  letter-spacing: 0.31px;
  color: rgba(0, 0, 0, 0.65);
}
.layout-container {
  .backtop {
    background: #3fb7ff;
    height: 100%;
    width: 100%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
  min-width: 1200px;
  width: 100%;
  flex: none;
  height: auto;
  min-height: 100vh;
  background-color: #e9edf0;
  .header {
    width: 100%;
    padding: 0;
    padding-bottom: 110px;
    background: #0044bb;
    background-image: url(../../src/assets/images/header_bg.png);
    background-image: url(../../src/assets/images/header_bg.png),
      linear-gradient(to bottom, #0044bb, #152476 80%, #000e5f);
    background-position: top right;
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .header-content {
      min-width: 1200px;
      width: calc(100% - 240px);
      margin: 0 120px;
      justify-content: space-between;
      align-items: flex-end;
      flex: none;
      .logo {
        width: 188px;
        height: 42px;
        flex: none;
        cursor: pointer;
      }
      .user-bar {
        display: flex;
        height: 25px;
        font-size: 25px;
        align-items: center;
        color: white;
        .file {
          background: transparent;
          border: none;
          color: white;
          font-size: 25px;
          width: 25px;
          margin-right: 34px;
        }
        .avatar {
          margin-right: 7px;
        }
        > span {
          margin-right: 34px;
          font-size: 20px;
          font-weight: 500;
          letter-spacing: -0.44px;
        }
        .quit {
          color: #7ae0ff;
          margin: 0 14px;
        }
      }
    }
  }
  .main-bg {
    min-height: calc(100vh - 426px);
    width: 100%;
    justify-content: center;
    .main {
      flex: none;
      width: calc(100% - 240px);
      position: relative;
      border-radius: 4px;
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
      background-color: #f4f6f8;
      margin: -65px 120px -89px 120px;
      flex-direction: column;
      &.fixed {
        padding-top: 65px;
      }
      .menu {
        height: 65px;
        border-radius: 4px;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.14);
        &.fixed {
          width: calc(100% - 240px);
          position: fixed;
          top: 0;
          z-index: 301;
        }
      }
      .main-content {
        padding: 0px;
        flex: none;
        overflow: visible;
        display: flex;
        height: 100%;
        flex-shrink: 1;
        .aside {
          width: 215px;
          border-radius: 0 0 0 4px;
          box-sizing: border-box;
          background: white;
          padding: 28px 36px;
          flex: none;
          .el-menu {
            border: none;
            .type-name {
              font-size: 14px;
              font-weight: 500;
              letter-spacing: -0.39px;
              color: #75808B;
              padding-top: 26px;
              &:first-child {
                padding-top: 0;
              }
            }
            .el-menu-item {
              padding: 0 !important;
              height: 34px;
              line-height: 34px;
              background: transparent !important;
              .svg-icon {
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
  }
  .footer {
    width: 100%;
    background: linear-gradient(to bottom, #003083 15%, #000835 98%);
    height: 228px;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    p {
      margin: 0;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: -0.33px;
      text-align: center;
      color: #75808b;
      &:last-child {
        margin-bottom: 58px;
      }
    }
  }
}

$break-small: 1200px;
$break-large: 1440px;

@media screen and (max-width: $break-small) {
  .layout-container {
    .header {
      .header-content {
        margin: 0 auto;
        width: 1200px;
      }
    }
    .main-bg {
      .main {
        width: 100%;
        margin: -65px auto -89px;
        .menu {
          &.fixed {
            width: 100%;
          }
        }
      }
    }
  }
}

@media screen and (max-width: $break-large) {
  .layout-container {
    .header {
      .header-content {
        width: 1200px;
        margin: 0 auto;
      }
    }
    .main-bg {
      .main {
        width: 1200px;
        margin: 0 auto;
        margin-top: -65px;
        margin-bottom: -89px;
        .menu {
          &.fixed {
            width: 1200px;
          }
        }
      }
    }
  }
}
</style>
